const COLLAPSED_LABEL = "Ver todas as perguntas";
const EXPANDED_LABEL = "Ver menos";
const ANIMATION_DURATION = 260;

function animateFaqContainer($container, expand) {
  const $content = $container.find("[data-faq-default-animated-content]");

  if (!$content.length) {
    if (expand) {
      $container.addClass("faq-default-expanded");
    } else {
      $container.removeClass("faq-default-expanded");
    }
    return;
  }

  const fromHeight = $content.outerHeight();

  if (expand) {
    $container.addClass("faq-default-expanded");
  } else {
    $container.removeClass("faq-default-expanded");
  }

  const toHeight = $content.outerHeight();

  $content
    .stop(true, true)
    .css({ height: fromHeight, overflow: "hidden" })
    .animate({ height: toHeight }, ANIMATION_DURATION, () => {
      $content.css({ height: "", overflow: "" });
    });
}

function syncFaqCategoryTitles($container) {
  const isExpanded = $container.hasClass("faq-default-expanded");
  const $accordion = $container.find("#accordion");

  $accordion.find(".category-title").each((_, element) => {
    const $title = $(element);
    const categoryId = $title.data("category");

    if (categoryId === undefined) {
      $title.removeAttr("hidden");
      return;
    }

    const $cards = $accordion.find(`.card-help[data-category='${categoryId}']`);
    const hasVisibleFaq = isExpanded
      ? $cards.length > 0
      : $cards.filter((__, card) => !$(card).is("[data-faq-hidden='true']")).length > 0;

    if (hasVisibleFaq) {
      $title.removeAttr("hidden");
    } else {
      $title.attr("hidden", "hidden");
    }
  });
}

function syncFaqToggleState($container) {
  const isExpanded = $container.hasClass("faq-default-expanded");
  const $toggle = $container.find("[data-faq-default-toggle-button]");

  if (!$toggle.length) {
    return;
  }

  $toggle.attr("aria-expanded", String(isExpanded));
  $toggle
    .find(".partners-toggle-label")
    .text(isExpanded ? EXPANDED_LABEL : COLLAPSED_LABEL);

  syncFaqCategoryTitles($container);
}

function collapseFaqDefault($container) {
  if (!$container.hasClass("faq-default-expanded")) {
    syncFaqToggleState($container);
    return;
  }

  animateFaqContainer($container, false);
  syncFaqToggleState($container);
}

export function initFaqDefaultToggle() {
  const $containers = $("#faq-default-content [data-faq-default-toggle='true']");

  if (!$containers.length) {
    return;
  }

  $containers.each((_, element) => {
    const $container = $(element);
    const $toggle = $container.find("[data-faq-default-toggle-button]");

    $toggle.off("click.faqDefaultToggle").on("click.faqDefaultToggle", () => {
      const isExpanded = $container.hasClass("faq-default-expanded");
      animateFaqContainer($container, !isExpanded);
      syncFaqToggleState($container);
    });

    syncFaqToggleState($container);
  });

  if (window.__quitejaFaqDefaultToggleBound) {
    return;
  }

  $(document).on("faq:default:restored", () => {
    $containers.each((_, element) => {
      collapseFaqDefault($(element));
    });
  });

  window.__quitejaFaqDefaultToggleBound = true;
}
